import { useState, useEffect } from 'react';

// Mock function to simulate fetching data based on version
const fetchFeaturesByVersion = (version) => {
    // Mock features history data
    const featureHistory = {
        '1.0.0': {
            newFeatures: [
                'Improved performance on the dashboard',
                'Fixed bugs in the payment module',
            ],
            bugFixes: [
                'Fixed login issue on mobile',
                'Resolved slow loading time on the settings page',
            ],
        },
        '1.1.0': {
            newFeatures: [
                'Introduced multi-language support',
                'Updated dashboard UI',
            ],
            bugFixes: [
                'Fixed issues with user authentication',
                'Improved data synchronization',
            ],
        },
        '1.2.5.021': {
            newFeatures: [
                'Added FIFO transactions',
                'Added supplier default location to Product Master',
                'Markup calculation based on cost and selling prices in Product Master',
                'Set default markup in Product Master',
                'New field for variant promotions in Promotion Group',
                'Create product bundles for stock codes'
            ],
            bugFixes: [
                'Fixed line number mismatch in transactions',
                'Resolved issue of same image being applied to multiple products in Product Master',
                'Error message not showing issue fixed in Masters',
            ]
        },
        '1.2.5.022': {
            newFeatures: [
                'Journal View added',
            ],
            bugFixes: [
                'Bom size decimal issue, decimal changed from 2 to 3',
            ]
        },
        '1.2.5.023': {
            newFeatures: [
                'Consignment process added',
            ],
            bugFixes: [
                'Special characters not entering in group master issue fixed',
            ]
        },
        '1.2.5.024': {
            newFeatures: [
                'New liquor process added to transactions.'
            ],
            bugFixes: [
                'Fixed issue where product codes previously could not contain special characters. Now, special characters are allowed in product codes.'
            ]
        },
        '1.2.5.025': {
            newFeatures: [
                'Added new reference fields to the Customer master.'
            ],
            bugFixes: [
                'Minor bug fixes and performance improvements.'
            ]
        },
        '1.2.5.026': {
            newFeatures: [
                'Added new option to skip approvals for certain customers in the transaction.',
                'Transaction excel download updated to add additional fields according to the customer request.'
            ],
            bugFixes: [
                'Product images save with unique code'
            ]
        },
        '1.2.5.027': {
            newFeatures: [
                'Introduced a new UI to display all system connections, including POS. A dedicated menu item has been added to access the UI via the "/SystemConnections" URL, with an authentication prompt requiring the password "system@admin123".',
                'Enhanced the product master by enabling users to add multiple inner case sizes in the reference tab. A new configuration parameter has been added to allow case size adjustments in transactions, which will dynamically update the cost price. This change requires careful testing due to its impact on transaction behavior.',
                'Enabled the ability to enter negative values for discount percentages and discount amounts.',
                'Implemented a validation feature to specify whether a product image is required during transaction processing.',
                'Introduced validation for weighted and multiple price combinations in product transactions.',
                'Added functionality to validate the customer NIC during transaction processing.',
                'Updated API endpoint to support the "/" route for improved flexibility.',
                'Enhanced the product master with a feature to manage supplier-specific free quantities. This functionality allows users to input quantities by supplier, with free quantity data retrieved from the associated table when the supplier and product are selected.'
            ],
            bugFixes: [
                'Fixed a bug where the transaction approval rule validation was not working correctly in some locations.'
            ]
        },
        '1.2.5.028': {
            newFeatures: [
                'Created a separate UI to display all the system connections including POS. A new menu is created to access the UI at "/SystemConnections". When loading the screen, it will always ask for the password "system@admin123".',
                'Added new column called PLU_SHORT_EXPIRY_DAYS to the M_TBLPROMASTER.',
                'Added a new button in the bincard UI to download an excel file.',
                'Current GP display line level set with TX_SHOWGP = 1.',
                'Added a popup to enter the date range and order cycle days.',
                'View button in transaction details can now be customized using different stored procedures. You can enter your SP in the TX_CUSTOMVIEW_SP column.',
                'Increased length of dropdown selection in the Journal View menu.',
                'Added a new column called TX_PRICEUPDATE_PRO_WISE to update product inventory price product-wise.',
                'Serial number validation has been enhanced to now validate the validity periods, JWT, and other relevant factors. Additionally, a system-generated serial number has been added to the license table, and the same serial number has been included in the SETUP table.'
            ],
            bugFixes: [
            ]
        },
        '1.2.5.030': {
            newFeatures: [
                'Decimal values are now allowed in `Qty From`, `Qty To`, and `Free Qty` columns.',
                'Send sms functionality has been added to the proceed transaction if the customer has a mobile number.',
            ],
            bugFixes: [
                'Search now also uses the `SEARCH` table. UI updated with debounce-based search functionality to reduce server load.'
            ]
        }

    };

    return featureHistory[version] || { newFeatures: [], bugFixes: [] }; // Default if version not found
};

const useFirstLogin = () => {
    const [isFirstLogin, setIsFirstLogin] = useState(false);
    const [features, setFeatures] = useState({ newFeatures: [], bugFixes: [] });
    const [version, setVersion] = useState(process.env.REACT_APP_VERSION); // Get version from environment variable

    const authToken = localStorage.getItem("authToken");
    const ApiURL = window.Links.ApiURL;

    const obj = JSON.parse(localStorage.getItem("authUser"))
    const user = obj[2]

    useEffect(() => {
        const fetchFirstLoginStatus = async () => {

            try {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`
                    },
                    body: JSON.stringify({ user })
                };

                const response = await fetch(`${ApiURL}user/firstLogin`, requestOptions);
                const result = await response.json();
                const responseData = result.data;

                if (responseData) {
                    setIsFirstLogin(true);
                } else {
                    setIsFirstLogin(false);
                }


                // Fetch features based on the version number
                const featuresForVersion = fetchFeaturesByVersion(version);
                setFeatures(featuresForVersion);

            } catch (error) {
                console.log('Error:', error);
                throw error;
            }
        };

        fetchFirstLoginStatus();
    }, [version]);



    // Function to update the first login status
    const updateFirstLoginStatus = async () => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify({ user })
            };

            const response = await fetch(`${ApiURL}user/firstLoginUpdate`, requestOptions);

        } catch (error) {
            console.log('Error:', error);
            throw error;
        }
    };

    return {
        isFirstLogin,
        updateFirstLoginStatus, // Return the update function
        features
    };


};

export default useFirstLogin;
